import React from 'react'
import { Grid, Typography, makeStyles } from '@material-ui/core'
import { FormikSwitchField } from 'components/form/SwitchField'
import { FormikFileSetField } from 'components/form/FileSetField'
import { FormikInputField } from 'components/form/InputField'
import { get } from 'lodash'


const useStyles = makeStyles((theme) => ({
  fieldDescription: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: -4,
    marginBottom: 4
  }
}))

export default function BeneficiaryVettingNpoDssFields({ formik_props, fieldsDisabled = false }) {
  const classes = useStyles()
  const company = get(formik_props.values, 'company', {})


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormikSwitchField
          name="company.is_registered_npo"
          label="Registered NPO?"
          formik_props={formik_props}
          color="primary"
          checked={get(company, 'is_registered_npo', false)}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Indicate if registered as an NPO. Request certificate if not already provided.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikInputField
          name="company.npo_number"
          type="text"
          label="NPO Registration Number"
          formik_props={formik_props}
          value={get(company, 'npo_number')}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Enter the official NPO registration number from the certificate.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikFileSetField
          max_num_files={1}
          name="company.npo_certificate_upload"
          formik_props={formik_props}
          label="NPO Certificate Upload"
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Upload a clear, legible copy of the NPO certificate.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikSwitchField
          name="company.is_registered_with_dsd"
          label="Registered with DSD?"
          formik_props={formik_props}
          color="primary"
          checked={get(company, 'is_registered_with_dsd', false)}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          State if the organisation is registered with the Department of Social Development.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikInputField
          max_num_files={1}
          name="company.dsd_registration_number"
          type="text"
          label="DSD Registration Number"
          formik_props={formik_props}
          value={get(company, 'dsd_registration_number')}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Enter the DSD registration number where applicable.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikFileSetField
          max_num_files={1}
          name="company.pbo_certificate_upload"
          formik_props={formik_props}
          label="PBO Certificate Upload"
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Upload the Public Benefit Organisation certificate where applicable.
        </Typography>
      </Grid>
    </Grid>
  )
}
